module.exports = __webpack_public_path__ + "static/media/new-logo-michpal-2.fb9d32b9.png";